function formatTimezoneOffset(isoDate: string, offsetInMinutes?: number) {
    // Using default browser offset if not explicitly specified.
    offsetInMinutes = offsetInMinutes ?? 0 - new Date(isoDate).getTimezoneOffset();

    const sign = offsetInMinutes < 0 ? '-' : '+';
    const hoursOffset = Math.floor(Math.abs(offsetInMinutes) / 60)
        .toFixed(0)
        .padStart(2, '0');
    const minuteOffset = Math.abs(offsetInMinutes % 60)
        .toFixed(0)
        .padStart(2, '0');
    return `${sign}${hoursOffset}:${minuteOffset}`;
}

export function formatDateTime(isoDate: string): string {
    return isoDate ? isoDate + formatTimezoneOffset(isoDate) : '';
}